import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row ms-3" }
const _hoisted_2 = { class: "col-lg-1 col-md-2 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_3 = { class: "col-lg-1 col-md-2 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_4 = { class: "row ms-3" }
const _hoisted_5 = { class: "col-lg-6 col-md-12 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_6 = { class: "col-lg-6 col-md-12 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_7 = { class: "col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_8 = { class: "row ms-3 mt-3" }
const _hoisted_9 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_10 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_11 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_12 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_13 = { class: "row ms-3 mt-3" }
const _hoisted_14 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_15 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_16 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_17 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_18 = { class: "row ms-3 mt-3" }
const _hoisted_19 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_20 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_21 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_22 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_23 = { class: "row ms-3 mt-3" }
const _hoisted_24 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_25 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_26 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_27 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_28 = { class: "row ms-3 mt-3" }
const _hoisted_29 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_30 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_31 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_32 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_33 = { class: "row ms-3 mt-3" }
const _hoisted_34 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_35 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_36 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_37 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_38 = { class: "row ms-3 mt-3" }
const _hoisted_39 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_40 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_41 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_42 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_43 = { class: "row ms-3 mt-3" }
const _hoisted_44 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_45 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_46 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_47 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_48 = { class: "row ms-3 mt-3" }
const _hoisted_49 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_50 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_51 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_52 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_53 = { class: "row ms-3 mt-3" }
const _hoisted_54 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_55 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_56 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_57 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_58 = { class: "row ms-3 mt-3" }
const _hoisted_59 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_60 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_61 = { class: "col-lg-3 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_62 = { class: "row ms-3 mt-5" }
const _hoisted_63 = { class: "col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_64 = { class: "col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_65 = { class: "col-lg-6 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_66 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_67 = { class: "row ms-3 mt-4" }
const _hoisted_68 = { class: "col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_69 = { class: "col-lg-1 col-md-3 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_70 = { class: "col-lg-6 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_71 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_72 = { class: "row ms-3 mt-4" }
const _hoisted_73 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_74 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_75 = { class: "col-lg-7 col-md-12 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_76 = { class: "row ms-3 mt-4" }
const _hoisted_77 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_78 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_79 = { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_80 = { class: "col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_81 = { class: "row ms-3 mt-4" }
const _hoisted_82 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_83 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_84 = { class: "row ms-3 mt-4" }
const _hoisted_85 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_86 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_87 = { class: "row ms-3 mt-4" }
const _hoisted_88 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_89 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_90 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_91 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_92 = { class: "row ms-3 mt-4" }
const _hoisted_93 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_94 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_95 = { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_96 = { class: "col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_97 = { class: "row ms-3 mt-4" }
const _hoisted_98 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_99 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_100 = { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_101 = { class: "col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_102 = { class: "row ms-3 mt-4" }
const _hoisted_103 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_104 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_105 = { class: "col-lg-7 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_106 = { class: "row ms-3 mt-4 mb-5" }
const _hoisted_107 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_108 = { class: "col-lg-1 col-md-6 col-sm-6 remove-form-group-bottom-margin" }
const _hoisted_109 = { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_110 = { class: "col-lg-4 col-md-6 col-sm-12 remove-form-group-bottom-margin" }
const _hoisted_111 = { class: "row mt-5 text-center" }
const _hoisted_112 = { class: "col-12" }

import { onMounted, ref, toRefs } from 'vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthQuestionnaireForm',
  props: {
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ['update:submitForm'],
  setup(__props, { emit: __emit }) {

const props = __props;

const documentId = toRefs(props)['documentId'];
const { t } = useI18n();
const isSubmitting = ref(false);
const emit = __emit;

const formData = ref<any>({
  alreadyBeenExaminedYes: false,
  alreadyBeenExaminedNo: false,
  alreadyBeenExaminedWhen: "",
  alreadyBeenExaminedWhere: "",
  reasonForExamination: "",
  heartDisease: false,
  highLowBlowPressure: false,
  bronchi: false,
  asthma: false,
  allergies: false,
  tonsillitis: false,
  diphtheria: false,
  skin: false,
  rheumatism: false,
  thyroid: false,
  gallbladder: false,
  liver: false,
  stomachAndIntestines: false,
  boneAndJointSystem: false,
  jaundice: false,
  kidneys: false,
  diabetes: false,
  concussion: false,
  sexuallyTransmittedDisease: false,
  gout: false,
  mentalIllness: false,
  neurologicalDiseases: false,
  varicoseVeins: false,
  noDiseases: false,
  visualImpairment: false,
  eyeProblems: false,
  headache: false,
  dizziness: false,
  sleepDisorders: false,
  earNoseEars: false,
  pains: false,
  seizures: false,
  lossOfAppetite: false,
  weightLoss: false,
  nightSweats: false,
  cough: false,
  digestiveComplaints: false,
  painfulUrination: false,
  rheumatism2: false,
  heartProblems: false,
  backPain: false,
  moodAndDriveFluctuations: false,
  nervousComplaints: false,
  appliedForAPensionNo: false,
  appliedForAPensionYes: false,
  appliedForAPensionReason: '',
  appliedForAPensionPercentage: '',
  severelyDisabledNo: false,
  severelyDisabledYes: false,
  severelyDisabledReason: '',
  severelyDisabledPercentage: '',
  undergoingTreatmentNo: false,
  undergoingTreatmentYes: false,
  undergoingTreatmentReason: '',
  takingMedicationNo: false,
  takingMedicationYes: false,
  takingMedicationWhich: '',
  takingMedicationSince: '',
  feelHealthyAnProductiveNo: false,
  feelHealthyAnProductiveYes: false,
  doAnySportsNo: false,
  doAnySportsYes: false,
  wearVisualAidsNo: false,
  wearVisualAidsYes: false,
  wearGlasses: false,
  wearContactLenses: false,
  smokeNo: false,
  smokeYes: false,
  smokeSince: '',
  smokeDailyAmount: '',
  drinkAlcoholicBeveragesNo: false,
  drinkAlcoholicBeveragesYes: false,
  drinkAlcoholicBeveragesSince: '',
  drinkAlcoholicBeveragesAmount: '',
  anyMedicationOrDrugsInLastYearNo: false,
  anyMedicationOrDrugsInLastYearYes: false,
  anyMedicationOrDrugsInLastYearSince: '',
  examinedForHealthNo: false,
  examinedForHealthYes: false,
  examinedForHealthWhere: '',
  examinedForHealthResult: ''
});

async function submitForm() {
  try {
    await unemployedPrivateCoachingService.saveHealthQuestionnaire(documentId.value, formData.value);

    isSubmitting.value = false;
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getDocumentData() {
  try {
    const { data } = await unemployedPrivateCoachingService.getHealthQuestionnaire(documentId.value);
    formData.value = { ...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getDocumentData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submitForm, ["prevent"])
  }, [
    _cache[98] || (_cache[98] = _createElementVNode("div", { class: "row" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase ps-3" }, " 1. Angaben zur Vorgeschichte ")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[86] || (_cache[86] = _createElementVNode("div", { class: "col-lg-6 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " Wurden Sie bereits in einem Gesundheitsamt untersucht? ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.alreadyBeenExaminedYes,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.alreadyBeenExaminedYes) = $event)),
          label: "Ja",
          "label-position": "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.alreadyBeenExaminedNo,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.alreadyBeenExaminedNo) = $event)),
          label: "Nein",
          "label-position": "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseInput, {
          modelValue: formData.value.alreadyBeenExaminedWhen,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.alreadyBeenExaminedWhen) = $event)),
          label: "Wann?",
          placeholder: "Datum oder Zeitraum"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseInput, {
          modelValue: formData.value.alreadyBeenExaminedWhere,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.alreadyBeenExaminedWhere) = $event)),
          label: "Wo?",
          placeholder: "Ort"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseInput, {
          modelValue: formData.value.reasonForExamination,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.reasonForExamination) = $event)),
          label: "Grund der Untersuchung",
          placeholder: "Bitte angeben..."
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[99] || (_cache[99] = _createElementVNode("div", { class: "row mt-5" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase ps-3" }, " 2. folgende Krankheiten/Krankheiten folgender Organe/Behinderungen lagen vor/liegen vor ")
    ], -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.heartDisease,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.heartDisease) = $event)),
          label: "Herzerkrankung",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.highLowBlowPressure,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.highLowBlowPressure) = $event)),
          label: "Hoher/Niedriger Blutdruck",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.bronchi,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.bronchi) = $event)),
          label: "Bronchien",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.asthma,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.asthma) = $event)),
          label: "Asthma",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.allergies,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.allergies) = $event)),
          label: "Allergien",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.tonsillitis,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.tonsillitis) = $event)),
          label: "Mandelentzündung",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.diphtheria,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.diphtheria) = $event)),
          label: "Diphtherie",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.skin,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.skin) = $event)),
          label: "Haut",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.rheumatism,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.rheumatism) = $event)),
          label: "Rheuma",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.thyroid,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.thyroid) = $event)),
          label: "Schilddrüse",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.gallbladder,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.gallbladder) = $event)),
          label: "Gallenblase",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.liver,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.liver) = $event)),
          label: "Leber",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.stomachAndIntestines,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.stomachAndIntestines) = $event)),
          label: "Magen & Darm",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.boneAndJointSystem,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.boneAndJointSystem) = $event)),
          label: "Knochen- & Gelenksystem",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.jaundice,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.jaundice) = $event)),
          label: "Gelbsucht",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.kidneys,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.kidneys) = $event)),
          label: "Nieren",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.diabetes,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.diabetes) = $event)),
          label: "Diabetes",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.concussion,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.concussion) = $event)),
          label: "Gehirnerschütterung",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.sexuallyTransmittedDisease,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.sexuallyTransmittedDisease) = $event)),
          label: "Geschlechtskrankheit",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.gout,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.gout) = $event)),
          label: "Gicht",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.mentalIllness,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.value.mentalIllness) = $event)),
          label: "Psychische Krankheit",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.neurologicalDiseases,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((formData.value.neurologicalDiseases) = $event)),
          label: "Neurologische Erkrankungen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.varicoseVeins,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.value.varicoseVeins) = $event)),
          label: "Krampfadern",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.noDiseases,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formData.value.noDiseases) = $event)),
          label: "Keine Erkrankungen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _cache[100] || (_cache[100] = _createElementVNode("div", { class: "row mt-5" }, [
      _createElementVNode("h6", { class: "mb-2 text-uppercase ps-3" }, "3. Jetzige Beschwerden oder Krankheiten")
    ], -1)),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.visualImpairment,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formData.value.visualImpairment) = $event)),
          label: "Sehstörung",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.eyeProblems,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formData.value.eyeProblems) = $event)),
          label: "Augen-beschwerden",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.headache,
          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((formData.value.headache) = $event)),
          label: "Kopf-schmerzen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.dizziness,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((formData.value.dizziness) = $event)),
          label: "Schwindel",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.sleepDisorders,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formData.value.sleepDisorders) = $event)),
          label: "Sleep Disorders",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.earNoseEars,
          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((formData.value.earNoseEars) = $event)),
          label: "Hals/Nase/Ohren",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.pains,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((formData.value.pains) = $event)),
          label: "Schmerzen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.seizures,
          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((formData.value.seizures) = $event)),
          label: "Anfälle",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.lossOfAppetite,
          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((formData.value.lossOfAppetite) = $event)),
          label: "Appetitlosigkeit",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.weightLoss,
          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formData.value.weightLoss) = $event)),
          label: "Gewichtsabnahme",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.nightSweats,
          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((formData.value.nightSweats) = $event)),
          label: "Nacht-schweiß",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.cough,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((formData.value.cough) = $event)),
          label: "Husten",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.digestiveComplaints,
          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((formData.value.digestiveComplaints) = $event)),
          label: "Verdauungs-beschwerden",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_55, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.painfulUrination,
          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((formData.value.painfulUrination) = $event)),
          label: "Schmerzhaftes Wasserlassen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.rheumatism2,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((formData.value.rheumatism2) = $event)),
          label: "Rheuma",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.heartProblems,
          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((formData.value.heartProblems) = $event)),
          label: "Herz-beschwerden",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.backPain,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((formData.value.backPain) = $event)),
          label: "Rückenschmerzen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_60, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.moodAndDriveFluctuations,
          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((formData.value.moodAndDriveFluctuations) = $event)),
          label: "Stimmungs- und Antriebs-schwankung",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.nervousComplaints,
          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((formData.value.nervousComplaints) = $event)),
          label: "Nervöse Beschwerden",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _cache[87] || (_cache[87] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 4. Haben Sie eine Rente beantragt? ", -1)),
      _createElementVNode("div", _hoisted_63, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.appliedForAPensionNo,
          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((formData.value.appliedForAPensionNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_64, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.appliedForAPensionYes,
          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((formData.value.appliedForAPensionYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _createVNode(BaseInput, {
          modelValue: formData.value.appliedForAPensionReason,
          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((formData.value.appliedForAPensionReason) = $event)),
          label: "Grund"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _createVNode(BaseInput, {
          modelValue: formData.value.appliedForAPensionPercentage,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((formData.value.appliedForAPensionPercentage) = $event)),
          label: "MdE %:"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_67, [
      _cache[88] || (_cache[88] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 5. Sind Sie schwerbehindert? ", -1)),
      _createElementVNode("div", _hoisted_68, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.severelyDisabledNo,
          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((formData.value.severelyDisabledNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.severelyDisabledYes,
          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((formData.value.severelyDisabledYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_70, [
        _createVNode(BaseInput, {
          modelValue: formData.value.severelyDisabledReason,
          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((formData.value.severelyDisabledReason) = $event)),
          label: "Grund"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_71, [
        _createVNode(BaseInput, {
          modelValue: formData.value.severelyDisabledPercentage,
          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((formData.value.severelyDisabledPercentage) = $event)),
          label: "GdB %:"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_72, [
      _cache[89] || (_cache[89] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 6. Sind Sie zurzeit in Behandlung? ", -1)),
      _createElementVNode("div", _hoisted_73, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.undergoingTreatmentNo,
          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((formData.value.undergoingTreatmentNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.undergoingTreatmentYes,
          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((formData.value.undergoingTreatmentYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createVNode(BaseInput, {
          modelValue: formData.value.undergoingTreatmentReason,
          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((formData.value.undergoingTreatmentReason) = $event)),
          label: "Grund"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _cache[90] || (_cache[90] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 7. Nehmen Sie zurzeit Medikamente ein? ", -1)),
      _createElementVNode("div", _hoisted_77, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.takingMedicationNo,
          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((formData.value.takingMedicationNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_78, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.takingMedicationYes,
          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((formData.value.takingMedicationYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_79, [
        _createVNode(BaseInput, {
          modelValue: formData.value.takingMedicationWhich,
          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((formData.value.takingMedicationWhich) = $event)),
          label: "Welche?"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createVNode(BaseInput, {
          modelValue: formData.value.takingMedicationSince,
          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((formData.value.takingMedicationSince) = $event)),
          label: "Seit wann?"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_81, [
      _cache[91] || (_cache[91] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 8. Fühlen Sie sich gesund und leistungsfähig? ", -1)),
      _createElementVNode("div", _hoisted_82, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.feelHealthyAnProductiveNo,
          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((formData.value.feelHealthyAnProductiveNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.feelHealthyAnProductiveYes,
          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((formData.value.feelHealthyAnProductiveYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_84, [
      _cache[92] || (_cache[92] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 9. Betätigen Sie sich sportlich? ", -1)),
      _createElementVNode("div", _hoisted_85, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.doAnySportsNo,
          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((formData.value.doAnySportsNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.doAnySportsYes,
          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((formData.value.doAnySportsYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_87, [
      _cache[93] || (_cache[93] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 10. Tragen Sie eine Sehhilfe? ", -1)),
      _createElementVNode("div", _hoisted_88, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.wearVisualAidsNo,
          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((formData.value.wearVisualAidsNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_89, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.wearVisualAidsYes,
          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((formData.value.wearVisualAidsYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.wearGlasses,
          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((formData.value.wearGlasses) = $event)),
          label: "Brille",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_91, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.wearContactLenses,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((formData.value.wearContactLenses) = $event)),
          label: "Kontaktlinsen",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_92, [
      _cache[94] || (_cache[94] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 11. Rauchen Sie? ", -1)),
      _createElementVNode("div", _hoisted_93, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.smokeNo,
          "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((formData.value.smokeNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_94, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.smokeYes,
          "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((formData.value.smokeYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_95, [
        _createVNode(BaseInput, {
          modelValue: formData.value.smokeSince,
          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((formData.value.smokeSince) = $event)),
          label: "Seit:"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_96, [
        _createVNode(BaseInput, {
          modelValue: formData.value.smokeDailyAmount,
          "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((formData.value.smokeDailyAmount) = $event)),
          label: "Tägliche Menge:"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_97, [
      _cache[95] || (_cache[95] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 12. Nehmen Sie regelmäßig alkoholische Getränke (auch Bier) zu sich? ", -1)),
      _createElementVNode("div", _hoisted_98, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.drinkAlcoholicBeveragesNo,
          "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((formData.value.drinkAlcoholicBeveragesNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_99, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.drinkAlcoholicBeveragesYes,
          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((formData.value.drinkAlcoholicBeveragesYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_100, [
        _createVNode(BaseInput, {
          modelValue: formData.value.drinkAlcoholicBeveragesSince,
          "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((formData.value.drinkAlcoholicBeveragesSince) = $event)),
          label: "Seit:"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_101, [
        _createVNode(BaseInput, {
          modelValue: formData.value.drinkAlcoholicBeveragesAmount,
          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((formData.value.drinkAlcoholicBeveragesAmount) = $event)),
          label: "Tägliche Menge:"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_102, [
      _cache[96] || (_cache[96] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 13. Haben Sie im letzten Jahr nicht verordnete Medikamente oder Drogen eingenommen? ", -1)),
      _createElementVNode("div", _hoisted_103, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.anyMedicationOrDrugsInLastYearNo,
          "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((formData.value.anyMedicationOrDrugsInLastYearNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_104, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.anyMedicationOrDrugsInLastYearYes,
          "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((formData.value.anyMedicationOrDrugsInLastYearYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_105, [
        _createVNode(BaseInput, {
          modelValue: formData.value.anyMedicationOrDrugsInLastYearSince,
          "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((formData.value.anyMedicationOrDrugsInLastYearSince) = $event)),
          label: "Seit:"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_106, [
      _cache[97] || (_cache[97] = _createElementVNode("div", { class: "col-lg-3 col-md-6 col-sm-12 remove-form-group-bottom-margin" }, " 14. Wurden Sie schonmal auf Ihre gesundheitliche Eignung untersucht? (z.B. Musterung) ", -1)),
      _createElementVNode("div", _hoisted_107, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.examinedForHealthNo,
          "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((formData.value.examinedForHealthNo) = $event)),
          label: "Nein",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_108, [
        _createVNode(BaseCheckbox, {
          modelValue: formData.value.examinedForHealthYes,
          "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((formData.value.examinedForHealthYes) = $event)),
          label: "Ja",
          labelPosition: "right"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_109, [
        _createVNode(BaseInput, {
          modelValue: formData.value.examinedForHealthWhere,
          "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((formData.value.examinedForHealthWhere) = $event)),
          label: "Wo:"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_110, [
        _createVNode(BaseInput, {
          modelValue: formData.value.examinedForHealthResult,
          "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((formData.value.examinedForHealthResult) = $event)),
          label: "Ergebnis:"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("div", _hoisted_112, [
        _createVNode(SaveButton, {
          label: _ctx.$t('general.button.save'),
          loading: isSubmitting.value
        }, null, 8, ["label", "loading"])
      ])
    ])
  ], 32))
}
}

})